import React, { forwardRef } from 'react';
import { BsSearchHeartFill } from 'react-icons/bs';
import { HiOutlineSearch } from 'react-icons/hi';

type SearchInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const SearchInput: React.FC<SearchInputProps> = forwardRef<
	HTMLInputElement,
	SearchInputProps
>(({ ...rest }, ref) => {
	return (
		<div className="relative">
			<input
				{...rest}
				ref={ref}
				className={`h-[38px] w-full min-w-[270px] rounded-[10px] bg-[#F4F7FE] pl-9 pr-2 text-xs outline-ring ${
					rest.className ?? ''
				}`}
			/>

			{import.meta.env.DEV ? (
				<BsSearchHeartFill
					size={16}
					color={'#1B2559'}
					className="absolute left-3 top-3"
				/>
			) : (
				<HiOutlineSearch
					size={16}
					color={'#1B2559'}
					className="absolute left-3 top-3"
				/>
			)}
		</div>
	);
});

SearchInput.displayName = 'SearchInput'; // Add display name

export default SearchInput;
